import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Loader2, RotateCcw } from "lucide-react";
import { joinWaitlist, errorMessage } from "../../lib/api";

export const QuickJoin = ({ onAgain, onFullForm }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await joinWaitlist({ email: email.trim(), interests: ["Kitchen Companion"], note: "Joined from the explainer video" });
      setDone(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div data-testid="quick-join-success" className="flex flex-col items-center gap-2 sm:gap-3">
        <p className="flex items-center gap-2 font-semibold text-white sm:text-lg"><CheckCircle2 className="h-5 w-5 text-cyan-300" /> You’re on the list!</p>
        <p className="text-xs text-slate-200 sm:text-sm">A welcome note from Honesti is on its way to {email.trim()}.</p>
        <button onClick={onAgain} data-testid="demo-end-replay-btn" className="btn-ghost mt-1 !px-5 !py-2 text-sm"><RotateCcw className="h-4 w-4" /> Watch again</button>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md">
      <form onSubmit={submit} data-testid="quick-join-form" className="flex gap-2 rounded-full border border-cyan-400/40 bg-ink/80 p-1.5 shadow-[0_0_24px_rgba(34,211,238,0.25)]">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" aria-label="Email address"
          data-testid="quick-join-email-input" className="min-w-0 flex-1 bg-transparent px-4 text-sm text-white placeholder:text-slate-400 focus:outline-none sm:text-base" />
        <button disabled={busy} data-testid="quick-join-submit-btn" className="btn-primary shrink-0 !px-4 !py-2 text-sm disabled:opacity-60 sm:!px-6 sm:!py-2.5">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Join <ArrowRight className="h-4 w-4" /></>}
        </button>
      </form>
      {error && <p data-testid="quick-join-error" className="mt-2 text-xs text-rose-300 sm:text-sm">{error}</p>}
      <div className="mt-2 flex items-center justify-center gap-4 text-xs text-slate-300 sm:mt-3 sm:text-sm">
        <button onClick={onAgain} data-testid="demo-end-replay-btn" className="flex items-center gap-1.5 hover:text-white"><RotateCcw className="h-3.5 w-3.5" /> Watch again</button>
        <span className="text-slate-500">·</span>
        <Link to="/waitlist" onClick={onFullForm} data-testid="demo-end-join-btn" className="hover:text-white">Full sign-up form</Link>
      </div>
    </div>
  );
};
